import jquery from 'jquery';

let $ = jquery;

export default function blocks() {
	let tabs = $('.wp-block-esg-tabs');
	let page_nav = document.querySelectorAll('.is-style-on-page-nav');

	// Tabs functionality
	if ( tabs.length ) {
		tabs.each(function () {
			let tab_container = $(this);

			$('.wp-block-esg-tabs__title-container', this).on('click', function() {
				if ( ! $(this).hasClass('active') ) {
					$('.wp-block-esg-tabs__title-container.active').removeClass('active');
					$('.wp-block-esg-tabs__content.active').removeClass('active');
					
					$('.wp-block-esg-tabs__content[data-tab-level="' + $(this).data('tab-level') + '"]').addClass('active');
					$(this).addClass('active');

					if ( window.outerWidth < 782 ) {
						// set scroll position to top of tab container, not animated
						$('html,body').scrollTop( $(this).offset().top );						
					}
				}
			});
		} );
	}

	// On page nav functionality
	if ( page_nav.length ) {
		page_nav.forEach( nav => {
			let nav_items = nav.querySelectorAll('a');
	
			nav_items.forEach( nav_item => {
				if ( nav_item.getAttribute('href').startsWith('#') ) {
					let target = document.querySelector(nav_item.getAttribute('href'));
					
					nav_item.addEventListener('click', function(e) {
						e.preventDefault();
	
						$('html,body').animate({
							scrollTop: $(target).offset().top - page_nav[0].offsetHeight
						}, 500);
					});
				}
			});
		});
	}
}
